import React, { useState, useCallback, useRef, useContext } from 'react';
import CIcon from '@coreui/icons-react';
import XLSX from 'xlsx';

import { FormCrawlTableContext } from '../FormCrawlRuleTable';
import ImportTableModal from '../../ImportTableModal';
import { exportToCSV, useOutsideHandling } from '../../../../../../../../utils';

const requiredText = '// required, any string';
const regexHeaderText = '// required, accepts a 1 or a 0';
const optionalAcceptText = '// optional, accepts a formId or a formClass';
const optionalText = '// optional, any string';

const ImportExportTable = () => {
     const { tableRow, setTableRow, resetBtnSaveStatus } = useContext(FormCrawlTableContext);
     const [showImportModal, setShowImportModal] = useState(false);
     const [showImportExport, setShowImportExport] = useState(false);

     const getHeaderValues = () => {
          const firstRowValues = [],
               secondRowValues = [];

          // Convert conditions to arrays which are compatible with XLSX
          if (Array.isArray(tableRow) && Array.isArray(tableRow[0].conditions)) {
               tableRow[0].conditions.forEach((condition) => {
                    const conditionValue = condition['g0'];

                    switch (conditionValue.key) {
                         case 'Page Location':
                              firstRowValues.push(requiredText, regexHeaderText);
                              secondRowValues.push(conditionValue.key, conditionValue.key + '.regex');
                              break;
                         case 'Match Type':
                              firstRowValues.push(optionalAcceptText);
                              secondRowValues.push(conditionValue.key);
                              break;
                         case 'Match Value':
                              firstRowValues.push(optionalText, regexHeaderText);
                              secondRowValues.push(conditionValue.key, conditionValue.key + '.regex');
                              break;
                         default:
                              firstRowValues.push(optionalText);
                    }
               });
          }

          return { firstRowValues, secondRowValues };
     };

     const exportToFile = (type = 'csv', fileName = 'table-import-export', onlyRow1And2) => {
          let { firstRowValues, secondRowValues } = getHeaderValues();

          // Many next rows
          let manyRowValues = [];

          if (!onlyRow1And2) {
               // Convert table rows, which begin from row fourth to arrays which are compatible with XLSX
               if (Array.isArray(tableRow)) {
                    tableRow.forEach(({ conditions }) => {
                         const rowValues = [];

                         if (Array.isArray(conditions)) {
                              conditions.forEach((condition) => {
                                   const conditionValue = condition['g0'];

                                   switch (conditionValue.key) {
                                        case 'Page Location':
                                        case 'Match Value':
                                             rowValues.push(conditionValue.value, conditionValue.isRegex ? '1' : '0');
                                             break;

                                        default:
                                             rowValues.push(conditionValue.value);
                                             break;
                                   }
                              });
                         }

                         manyRowValues.push(rowValues);
                    });
               }
          }

          let dataToExport = [firstRowValues, secondRowValues, ...manyRowValues];

          if (type === 'csv') {
               exportToCSV(`${fileName}.${type}`, dataToExport);
          } else {
               var workSheet = XLSX.utils.aoa_to_sheet(dataToExport);

               // Add to workbook
               let workBook = XLSX.utils.book_new();
               XLSX.utils.book_append_sheet(workBook, workSheet, 'Sheet1');

               // If uses XLSX.writeFile to export csv file, open that file then Ctrl + S to save,
               // then close file without saving changes, open that file again all values
               // of each rows will merge into the first column of that row, so use another function to export csv file
               XLSX.writeFile(workBook, `${fileName}.${type}`);
          }
     };

     const handClickImportExport = useCallback(() => {
          setTimeout(() => {
               setShowImportExport(!showImportExport);
          }, 100);
     }, [showImportExport]);

     const handleClickOutside = useCallback(() => {
          if (!showImportModal) {
               setShowImportExport(false);
          }
     }, [showImportModal]);

     const wrapperRef = useRef(null);
     useOutsideHandling(wrapperRef, handleClickOutside);

     const toggleImportModal = useCallback(() => {
          if (!showImportModal) {
               setShowImportExport(false);
          }

          setShowImportModal(!showImportModal);
     }, [showImportModal]);

     return (
          <>
               <div className="import-export-wrapper">
                    <div className="import-export">
                         <CIcon icon="cil-chevron-double-down" height={14} />
                         <button type="button" onClick={handClickImportExport}>
                              Import/Export
                         </button>
                    </div>
                    <ul ref={wrapperRef} className={showImportExport ? '' : 'hidden'}>
                         <li>
                              <button color="primary" type="button" onClick={() => exportToFile('csv')}>
                                   <CIcon icon="cil-cloud-download" height={14} />
                                   <span>Export existing table values</span>
                              </button>
                         </li>
                         <li>
                              <button color="primary" type="button" onClick={toggleImportModal}>
                                   <CIcon icon="cil-cloud-upload" height={14} />
                                   <span>Import new table values</span>
                              </button>
                         </li>
                    </ul>
               </div>
               <ImportTableModal
                    show={showImportModal}
                    onClose={() => setShowImportModal(false)}
                    toggleModal={toggleImportModal}
                    exportToFile={exportToFile}
                    getHeaderValues={getHeaderValues}
                    tableRow={tableRow}
                    setTableRow={setTableRow}
                    resetBtnSaveStatus={resetBtnSaveStatus}
                    variablesUseRegex={['FormCategory']}
               />
          </>
     );
};

export default ImportExportTable;
